import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-vehicle-placeholder',
  templateUrl: './vehicle-placeholder.component.html',
  styleUrls: ['./vehicle-placeholder.component.css']
})
export class VehiclePlaceholderComponent implements OnInit {

  @Input() count: number;

  constructor() { }

  ngOnInit(): void {
  }

}
